export default "assets/images/icons/cart-57c84803.svg";